/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Bar-chart': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<g opacity=".8" _fill="#9BC225"><path pid="0" d="M2 11h13v4H2v-4zM2 16.5h9v4H2v-4zM2 0h19v4H2V0zM0 0h1v20.5H0V0zM2 5.5h16v4H2v-4z"/></g>'
  }
})
